/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import { t } from "i18n";

const checkEmptyAndNumber = (translator) => {
  return {
    presence: { allowEmpty: false, message: translator("errors.validations.character-empty") },
    numericality: {
      onlyInteger: true,
      greaterThan: 0,
      message: translator("errors.validations.positive-int-expected")
    }
  };
};

export const constraints = (translator: typeof t) => {
  return {
    name: { presence: { allowEmpty: false } },
    "config.fields.headline.validations.hard-limit": checkEmptyAndNumber(translator),
    "config.fields.subheadline.validations.hard-limit": checkEmptyAndNumber(translator),
    "config.fields.meta-title.validations.hard-limit": checkEmptyAndNumber(translator),
    "config.fields.meta-description.validations.hard-limit": checkEmptyAndNumber(translator),
    "config.fields.summary.validations.hard-limit": checkEmptyAndNumber(translator),
    "config.fields.hero-image-attribution.validations.hard-limit": checkEmptyAndNumber(translator),
    "config.fields.hero-image-caption.validations.hard-limit": checkEmptyAndNumber(translator)
  };
};
